import { gsap, ScrollTrigger } from "@gsap";

const root = document.documentElement;
const token = (name) => getComputedStyle(root).getPropertyValue(`--pk-reveal-${name}`).trim();
const autoSelector = () => token("auto").replace(/^["']|["']$/g, "") || ".flex-layout .pk-module";

const settings = () => ({
	duration: parseFloat(token("duration")) || 1.1,
	distance: parseFloat(token("distance")) || 56,
	scale: parseFloat(token("scale")) || 0.94,
	stagger: parseFloat(token("stagger")) || 0.1,
	ease: token("ease") || "expo.out",
	start: token("start") || "90%",
});

const presets = (s) => ({
	"fade-up": { autoAlpha: 0, y: s.distance },
	"fade-down": { autoAlpha: 0, y: -s.distance },
	"fade-left": { autoAlpha: 0, x: s.distance },
	"fade-right": { autoAlpha: 0, x: -s.distance },
	fade: { autoAlpha: 0 },
	scale: { autoAlpha: 0, scale: s.scale },
});

function pkReveal(scope = document) {
	const auto = autoSelector();
	const elements = gsap.utils
		.toArray(scope.querySelectorAll(`[data-reveal], ${auto}`))
		.filter((el) => !el.dataset.revealInit && el.dataset.reveal !== "none")
		.filter((el) => el.hasAttribute("data-reveal") || !el.parentElement.closest(auto));

	elements.forEach((el) => (el.dataset.revealInit = "true"));

	gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
		const s = settings();
		const map = presets(s);

		elements.forEach((el) => gsap.set(el, map[el.dataset.reveal] || map["fade-up"]));
		root.classList.remove("pk-reveal-pending");

		ScrollTrigger.batch(elements, {
			start: `top ${s.start}`,
			once: true,
			onEnter: (batch) =>
				gsap.to(batch, {
					autoAlpha: 1,
					x: 0,
					y: 0,
					scale: 1,
					duration: s.duration,
					ease: s.ease,
					stagger: s.stagger,
					overwrite: true,
				}),
		});
	});

	root.classList.remove("pk-reveal-pending");
}

window.pkReveal = pkReveal;

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => pkReveal());
} else {
	pkReveal();
}
